import * as React from "react";
const SvgUpgrade20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 3.586L14.414 9 13 10.414l-2-2V15H9V8.414l-2 2L5.586 9 10 4.586Z",
      clipRule: "evenodd"
    })
  );
export default SvgUpgrade20Px;
